import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { HANDBOOK_TEMPLATE_LVL } from "../model/slice";
import { useTypedSelector } from "app/store/typedUseSelector";

import { useQueryParams } from "utils/hooks/useQueryParams";

/** Возвращает утровень вложенности в структуру шаблона.
Должен вызываться внутри Route с параметрами шаблонов */
const useHandbookLvl = () => {
  const { templateId, sectionId, subSectionId } = useParams<{
    templateId: string;
    sectionId?: string;
    subSectionId?: string;
  }>();
  // страница /templates/{templateId}/expenditures?segment=
  const segmentId = useQueryParams("segment");
  const templateViewFilters = useTypedSelector((state) => state.handBookReducer.templateViewFilters);

  const [lvl, setLvl] = useState(HANDBOOK_TEMPLATE_LVL.TEMPLATES);

  useEffect(() => {
    // Просматриваем структуру подсекции или отдельную страницу расценок
    if (!!subSectionId || (!sectionId && segmentId) || (sectionId === "expenditures" && segmentId)) {
      setLvl(HANDBOOK_TEMPLATE_LVL.EXPENDITURES);
      return;
    }
    // Просматриваем структуру раздела (список подсекций) или структуру шаблона (список разделов)
    if (sectionId || templateId) {
      setLvl(templateViewFilters.attribute ? HANDBOOK_TEMPLATE_LVL.SEGMENTS : HANDBOOK_TEMPLATE_LVL.SECTIONS);
      return;
    }
    setLvl(HANDBOOK_TEMPLATE_LVL.TEMPLATES);
  }, [templateId, sectionId, subSectionId, segmentId, templateViewFilters.attribute]);

  return { handbookLvl: lvl, templateId, sectionId, subSectionId };
};
export default useHandbookLvl;
